import React from 'react';
import { motion } from 'framer-motion';
export function AICapabilities() {
  return <section className="py-24 bg-stone-900 text-stone-50" data-id="element-1174">
      <div className="max-w-6xl mx-auto px-6" data-id="element-1175">
        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-1176">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16" data-id="element-1177">
            {/* Left: Header */}
            <div className="lg:col-span-4" data-id="element-1178">
              <p className="font-mono text-xs uppercase tracking-widest text-stone-400 mb-6" data-id="element-1179">
                RateBrain Intelligence
              </p>

              <h2 className="font-serif text-4xl tracking-tight leading-[1.1] text-stone-50 mb-6" data-id="element-1180">
                AI-powered pricing that protects your margins
              </h2>

              <p className="text-lg text-stone-400 leading-relaxed" data-id="element-1181">
                RateBrain analyzes competitive pricing, demand patterns, and
                market intelligence to deliver optimal dynamic pricing for every
                group quote. Not a black box — transparent recommendations you
                can trust.
              </p>
            </div>

            {/* Right: Capabilities */}
            <div className="lg:col-span-8" data-id="element-1182">
              <div className="border-t border-stone-700" data-id="element-1183">
                <div className="py-6 border-b border-stone-700" data-id="element-1184">
                  <div className="flex items-start gap-6" data-id="element-1185">
                    <span className="font-mono text-xs text-red-600 mt-1" data-id="element-1186">
                      01
                    </span>
                    <div data-id="element-1187">
                      <p className="text-stone-50 font-medium mb-2" data-id="element-1188">
                        Dynamic Rate Optimization
                      </p>
                      <p className="text-stone-400" data-id="element-1189">
                        Analyze real-time demand, seasonality, and competitive
                        set pricing to recommend optimal group rates. Maximize
                        RevPAR while staying competitive.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-700" data-id="element-1190">
                  <div className="flex items-start gap-6" data-id="element-1191">
                    <span className="font-mono text-xs text-red-600 mt-1" data-id="element-1192">
                      02
                    </span>
                    <div data-id="element-1193">
                      <p className="text-stone-50 font-medium mb-2" data-id="element-1194">
                        RFP Intelligence
                      </p>
                      <p className="text-stone-400" data-id="element-1195">
                        Parse incoming RFPs from any format — email, PDF,
                        WhatsApp. Extract dates, rooms, budgets, and
                        requirements automatically in seconds.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-700" data-id="element-1196">
                  <div className="flex items-start gap-6" data-id="element-1197">
                    <span className="font-mono text-xs text-red-600 mt-1" data-id="element-1198">
                      03
                    </span>
                    <div data-id="element-1199">
                      <p className="text-stone-50 font-medium mb-2" data-id="element-1200">
                        Competitive Set Analysis
                      </p>
                      <p className="text-stone-400" data-id="element-1201">
                        Monitor competitor pricing across your market. Know
                        exactly where you stand and when to adjust. Real-time
                        rate shopping intelligence.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="py-6 border-b border-stone-700" data-id="element-1202">
                  <div className="flex items-start gap-6" data-id="element-1203">
                    <span className="font-mono text-xs text-red-600 mt-1" data-id="element-1204">
                      04
                    </span>
                    <div data-id="element-1205">
                      <p className="text-stone-50 font-medium mb-2" data-id="element-1206">
                        Negotiation Copilot
                      </p>
                      <p className="text-stone-400" data-id="element-1207">
                        AI-powered counter-offer suggestions that protect
                        margins while maximizing close probability. Enforce
                        pricing consistency across your team.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="py-6" data-id="element-1208">
                  <div className="flex items-start gap-6" data-id="element-1209">
                    <span className="font-mono text-xs text-red-600 mt-1" data-id="element-1210">
                      05
                    </span>
                    <div data-id="element-1211">
                      <p className="text-stone-50 font-medium mb-2" data-id="element-1212">
                        Predictive Analytics
                      </p>
                      <p className="text-stone-400" data-id="element-1213">
                        Close-probability scoring, demand forecasting, and price
                        elasticity modeling. Know which groups to prioritize and
                        when to flex on rate.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}